import React from 'react';
import { connect } from 'react-redux';
import { Page } from 'signoxe/components';
import { getAsset } from 'signoxe/selectors';
import Box from '../../layout/Box';
import Button from '../../widgets/Button';
import {
  addUrlAsset, fetchUrlAssets, setPageTitle, updateUrlAsset,
} from '../../../actions';
// import './styles.scss';


class URLAssetEditPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {...props.asset};
  }

  componentDidMount() {
    this.props.fetchUrlAssets();
    if (this.props.asset) {
      this.props.setPageTitle(`${this.props.asset.id ? 'Editing' : 'Adding'} URL Asset`);
    } else {
      this.props.setPageTitle('Adding URL Asset');
    }
  }

  handleCancel = () => this.props.history.push('/assets');

  handleNameChange = (e) => this.setState({name: e.currentTarget.value});

  handleUrlChange = (e) => this.setState({asset_url: e.currentTarget.value});

  handleSave = () => {
    this.props.addUrlAsset(this.state);
    // this.props.disable();
    setTimeout(this.props.refresh, 700)
  };

  isNewAsset = () => this.props.match.params.id === undefined;

  saveEnabled() {
    return this.state && this.state.name && this.state.asset_url;
  }

  render() {
    return <div className="asset-dff">
      <input type="text" placeholder="Asset name"
             value={this.state.name}
             onChange={this.handleNameChange}/>
      <input type="url" placeholder="Content URL"
             value={this.state.asset_url}
             onChange={this.handleUrlChange}/>

      <Box direction="row" justifyContent="flex-end" className="actions button-group">
        <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>Save</Button>
        {/* <Button secondary onClick={this.handleCancel}>Cancel</Button> */}
      </Box>
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    // asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle: title => dispatch(setPageTitle(title)),
    addUrlAsset: data => dispatch(addUrlAsset(data)),
    fetchUrlAssets: () => dispatch(fetchUrlAssets()),
    updateUrlAsset: (id, data) => dispatch(updateUrlAsset(id, data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(URLAssetEditPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/AssetModal/components/Url.js